import {
    Box,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper
} from '@mui/material';
import {
    useSelector,
    // useDispatch
} from 'react-redux';
// import { getKilnDimensions } from '../../../../../../actions/forms';
import { useEffect } from 'react';
import { Unit, VolumetricUnit } from './utils/kiln-card-utils';

export default function KilnList({
    kilnType
}) {
    // const dispatch = useDispatch()
    const logKilns = useSelector(state => state.rofBurnsReducer.logKilns)?.data;
    // const kilnDimensions = useSelector((state) => (state.postFormData.kilnDimensions))
    // const loading = useSelector((state) => (state.postFormData.loading))

    useEffect(() => {
        // getKilnDimensions(id)
    }, [])

    const ringOfFireTableColumns = [
        'Id',
        'Created At',
        'Kiln Type',
        'Kiln Id',
        'Unit',
        'Rof Diameter',
        'Rof Panel Height',
        'Rof Panel Width',
        'Rof Panel Length',
        'Kiln Floor Area',
        'Kiln Empty Volume',
        'Panel Area',
    ];

    const umptopiaTableColumns = [
        'ID',
        'Created At',
        'Kiln Type',
        'Kiln ID',
        'Shape',
        'Unit',
        'Height of Inner Panels',
        'Width of Inner Panels',
        'Length of Inner Panels',
        'Kiln Length',
        'Kiln Width',
        'Floor Area',
        'Empty Volume',
        'Panel Area'
    ]

    const conservationBurnColumns = [
        'Id',
        'Created At',
        'Burn Type',
        'CB Id',
        'Diameter',
        'Height'
    ];

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {kilnType === 'Ring of Fire' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <Typography variant='h5'>
                        Ring of Fire Kilns
                    </Typography>
                    <TableContainer component={Paper} sx={{ height: 'auto' }}>
                        <Table aria-label='simple table'>
                            <TableHead>
                                <TableRow>
                                    {ringOfFireTableColumns.map((column, index) => (
                                        <TableCell align='left'
                                            key={index}>{column}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {logKilns?.map((row, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                '&:last-child td, &:last-child th': { border: 0 },
                                            }}
                                        >
                                            <TableCell align='left'>{row.id}</TableCell>
                                            <TableCell align='left'>
                                                {new Date(row.createdAt).toDateString()}
                                            </TableCell>
                                            <TableCell align='left'>{row.kilnType}</TableCell>
                                            <TableCell align='left'>{row.name}</TableCell>
                                            <TableCell align='left'>{row.units}</TableCell>
                                            <TableCell align='left'>
                                                {row.diameter}
                                                <Unit unit={row.units} />
                                            </TableCell>
                                            <TableCell align='left'>
                                                {row.heightOfInnerPanels}
                                                <Unit unit={row.units} />
                                            </TableCell>
                                            <TableCell align='left'>
                                                {row.heatShieldPanelWidth}
                                                <Unit unit={row.units} />
                                            </TableCell>
                                            <TableCell align='left'>
                                                {row.heatShieldPanelLength}
                                                <Unit unit={row.units} />
                                            </TableCell>
                                            <TableCell align='left'>
                                                {row.kilnFArea}
                                                <VolumetricUnit unit={row.units} volumeType={'squared'} />
                                            </TableCell>
                                            <TableCell align='left'>
                                                {row.emptyVol}
                                                <VolumetricUnit unit={row.units} volumeType={'cubed'} />
                                            </TableCell>
                                            <TableCell align='left'>
                                                {row.panelArea}
                                                <VolumetricUnit unit={row.units} volumeType={'squared'} />
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            )}
            {kilnType === 'Umptopia' &&
                (
                    <>
                        <Typography variant='h5' sx={{ mb: 2, mt: 2 }}>
                            Umptopia Kilns
                        </Typography>
                        <TableContainer component={Paper} sx={{ height: 'auto' }}>
                            <Table aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        {umptopiaTableColumns.map((column, index) => (
                                            <TableCell align='left' key={index}>{column}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {logKilns?.map((row, index) => {
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    '&:last-child td, &:last-child th': { border: 0 },
                                                }}
                                            >
                                                <TableCell align='left'>{row.id}</TableCell>
                                                <TableCell align='left'>
                                                    {new Date(row.createdAt).toDateString()}
                                                </TableCell>
                                                <TableCell align='left'>{row.kilnType}</TableCell>
                                                <TableCell align='left'>{row.name}</TableCell>
                                                <TableCell align='left'>{row.shape}</TableCell>
                                                <TableCell align='left'>{row.units}</TableCell>
                                                <TableCell align='left'>
                                                    {row.heightOfInnerPanels}
                                                    <Unit unit={row.units} />
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {row.heatShieldPanelWidth}
                                                    <Unit unit={row.units} />
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {row.heatShieldPanelLength}
                                                    <Unit unit={row.units} />
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {row.kilnLength ?? 'N/A'}
                                                    {(row.units === 'feet' && row.kilnLength) ? ' ft' : null}
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {row.kilnWidth ?? 'N/A'}
                                                    {(row.units === 'feet' && row.kilnWidth) ? ' ft' : null}
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {row.kilnFArea}
                                                    <VolumetricUnit unit={row.units} volumeType={'squared'} />
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {row.emptyVol}
                                                    <VolumetricUnit unit={row.units} volumeType={'cubed'} />
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {row.panelArea}
                                                    <VolumetricUnit unit={row.units} volumeType={'squared'} />
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )
            }
            {(kilnType === 'Conservation Burn - Hand Pile'
                || kilnType === 'Conservation Burn - Machine Pile') && (
                    <>
                        <Typography variant='h5' sx={{ mb: 2, mt: 2 }}>
                            Conservation Burns Piles
                        </Typography>
                        <TableContainer component={Paper} sx={{ height: 'auto' }}>
                            {/* {loading ? <h1>Loading</h1> : */}
                            <Table aria-label='simple table'>
                                <TableHead>
                                    <TableRow>
                                        {conservationBurnColumns.map((column, index) => (
                                            <TableCell align='left' key={index}>{column}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {logKilns?.map((column, index) => {
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    '&:last-child td, &:last-child th': { border: 0 },
                                                }}
                                            >
                                                <TableCell align='left'>{column.id}</TableCell>
                                                <TableCell align='left'>
                                                    {new Date(column.createdAt).toDateString()}
                                                </TableCell>
                                                <TableCell align='left'>{column.kilnType}</TableCell>
                                                <TableCell align='left'>{column.name}</TableCell>
                                                <TableCell align='left'>
                                                    {column.diameter}
                                                    <Unit unit={column.units} />
                                                </TableCell>
                                                <TableCell align='left'>
                                                    {column.height}
                                                    <Unit unit={column.units} />
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                )}
        </Box>
    );
}